<template>
	<div>
		<div class="breadcrumbs" id="breadcrumbs">
			<router-link class="breadcrumb-link" to="/campaigns/">All Bookblock HUB Campaigns</router-link>  &gt;
			<router-link class="breadcrumb-link" :to="'/campaigns/' + item.id">{{ item.name }}</router-link>  &gt;
            <router-link class="breadcrumb-link" :to="'/campaigns/' + item.id">Analytics</router-link>
		</div>
		<h3>{{ item.name }} <span>Campaign Analytics</span></h3>

        <div class="ws-large-tab-menu">
			<router-link :to="'/campaigns/' + item.id">Summary</router-link>
			<router-link :to="'/campaigns/' + item.id + '#recipients'">Recipients</router-link>
			<router-link :to="'/campaigns/' + item.id + '/analytics'">Analytics</router-link>
		</div>

		<gift-box-campaigns-analytics :item="item" :params="analyticsParams" @configureSales="configureSales"></gift-box-campaigns-analytics>
		<gift-box-campaigns-edit-modal v-if="modals.editGiftBoxCampaign" @updated="onCampaignUpdated" :tab="editModalTab"></gift-box-campaigns-edit-modal>
	</div>
</template>

<script>
import GiftBoxCampaignsAnalytics from '@/pages/gift-box-campaigns/components/GiftBoxCampaignsAnalytics';
import GiftBoxCampaignsEditModal from '@/pages/gift-box-campaigns/GiftBoxCampaignsEditModal';

export default {
	name: "GiftBoxCampaignsAnalyticsPage",
	components: {GiftBoxCampaignsAnalytics,GiftBoxCampaignsEditModal},
	data() {
		return {
			editModalTab: 'sales',
            analyticsParams: {
                mode: 'analytics',
                userRange: 'all',
                dateRange: 'all-time',
				sendsChart: {
                    year: null,
                    month: 'all',
                },
				opensChart: {
                    year: null,
                    month: 'all',
                },
				spentChart: {
                    year: null,
                    month: 'all',
                }
            }
		}
	},
	methods: {
		async fetchData() {
			const d = new Date();
			this.analyticsParams.sendsChart.year = d.getFullYear();
			this.analyticsParams.opensChart.year = d.getFullYear();
			this.analyticsParams.spentChart.year = d.getFullYear();

			await this.dispatchWaitAndNotify('fetchGiftBoxCampaign', {
				campaignId: this.$route.params.id,
				params: {
					with_option_counts: true,
					analytics: this.analyticsParams
				}
			}, false, true);
		},
		configureSales() {
			this.editModalTab = 'sales';
			this.modals.editGiftBoxCampaign = true;
		},
		onCampaignUpdated() {
			this.modals.editGiftBoxCampaign = false;
			this.fetchData();
		}
	},
	mounted() {
		this.fetchData();
	},
	computed: {
		team() {
			return this.$store.state.team.detail;
		},
		user() {
            return this.$store.state.currentUser;
        },
		item() {
			return this.$store.state.giftBoxCampaign.detail;
		},
		modals() {
			return this.$store.state.modals;
		},
	},
}
</script>

<style>

</style>
